import getDistanceUtm from './getDistanceUtm'
import findClosestPointOnPerimeter from './findClosestPointOnPerimeter'

export default function distanceOnPerimeter(point, perimeter) {
  const { coordinates } = point.geometry
  const closestPoint = findClosestPointOnPerimeter(coordinates, perimeter)
  return getDistanceUtm(closestPoint, { lat: coordinates[0], lng: coordinates[1] })
}
